import styled from 'styled-components';

import { body2, caption, colors } from 'ui/theme';
import { FilterCampaignOptionObject } from './FilterCampaignInput.types';

const Title = styled.div`
  ${body2}
`;

const Subtitle = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;

export const FilterCampaignOption = ({ id, name, messageMedium }: FilterCampaignOptionObject) => (
  <div>
    <Title>{name}</Title>
    <Subtitle>
      {messageMedium} | ID: {id}
    </Subtitle>
  </div>
);
